export default "__VITE_ASSET__LGomqbKz__"